<template>

  <svg viewBox="0 0 24 24" role="presentation" focusable="false" width="24" height="24" xmlns="http://www.w3.org/2000/svg"><path d="M22.95 14.1a.75.75 0 01-1.05-.15A4.839 4.839 0 0018 12a.75.75 0 110-1.5 2.25 2.25 0 10-2.179-2.813.75.75 0 11-1.453-.375 3.75 3.75 0 116.163 3.704 6.368 6.368 0 012.572 2.032.749.749 0 01-.153 1.051zm-5.052 5.774a.751.751 0 11-1.297.75 5.344 5.344 0 00-9.202 0 .751.751 0 11-1.298-.75 6.756 6.756 0 013.163-2.805 4.5 4.5 0 115.471 0 6.756 6.756 0 013.163 2.805zM12 16.5a3 3 0 100-6 3 3 0 000 6zm-5.25-5.25A.75.75 0 006 10.5a2.25 2.25 0 112.179-2.812.75.75 0 101.453-.375 3.75 3.75 0 10-6.163 3.704 6.368 6.368 0 00-2.57 2.032.75.75 0 101.2.901A4.838 4.838 0 016 12a.75.75 0 00.75-.75z"/></svg>

</template>


<script>

  export default {"name":"icon-3b5ac1f27fe09775516edf265eb7e029"}

</script>